import React from 'react';
import WidgetMachinesSection from 'components/quote_builder_widget/sections/WidgetMachinesSection';

const PRINTING_MACHINE_LABELS = {
  add: 'add_printing_machine',
  addTitle: 'add_printing_machine_to_widget',
  select: 'select_printing_machine',
  noneAdded: 'no_printing_machines_enabled',
  noMachines: 'no_printing_machines',
  allAdded: 'all_printing_machines_added',
  notUsed: 'printing_machine_not_used',
  failedToLoad: 'failed_to_load_printing_machines',
  failedToUpdate: 'failed_to_update_printing_machine',
  createNew: 'create_new_printing_machine',
};

const PrintingMachinesSection = ({ onPrintingMachinesChange, onAddedCountChange }) => (
  <WidgetMachinesSection
    machineKey="printing_machine"
    listUrl="/quote-builder/widgets/printing-machines"
    listField="printing_machines"
    allowedTypesField="accepted_printing_types"
    labels={PRINTING_MACHINE_LABELS}
    onMachinesChange={onPrintingMachinesChange}
    onAddedCountChange={onAddedCountChange}
  />
);

export default PrintingMachinesSection;
